import { TimezoneOption } from "@core/features/timezones";

export type Args = {
  /** Array of date strings in ISO format (e.g., ['2025-01-15', '2025-01-16']) */
  utcDates: string[];
  /** User's selected timezone (used for validation, dates are treated as local) */
  timezone: TimezoneOption;
  /** Grid start hour in local time (e.g., 6 for 6 AM) - unused but kept for API compatibility */
  startHour: number;
  /** Grid end hour in local time (e.g., 23 for 11 PM) - unused but kept for API compatibility */
  endHour: number;
};

export type Result = {
  /** Array of local date strings in ISO format */
  localDates: string[];
  /** Number of columns to render */
  columnCount: number;
};

/**
 * Returns the provided dates as local dates for display.
 * The dates are treated as local dates in the user's timezone.
 * 
 * Note: Previously this function tried to expand UTC dates based on timezone offset,
 * but this was overly complex. Now we simply use the provided dates directly.
 */
export function getLocalDateRangeFromUtcDates({
  utcDates,
  timezone,
}: Args): Result {
  if (!utcDates || utcDates.length === 0 || !timezone?.name) {
    return { localDates: [], columnCount: 0 };
  }

  // Sort dates and return them as-is (they represent local dates to display)
  const localDates = [...utcDates].sort();

  return {
    localDates,
    columnCount: localDates.length,
  };
}

export default getLocalDateRangeFromUtcDates;

